import React from "react";
import { Menu } from "@headlessui/react";
import { Trans } from "@lingui/macro";
import cx from "classnames";
import ExternalLink from "components/ExternalLink/ExternalLink";
import shevronDown from "img/shevron-down-circle.svg";

function MenuToggle({ children }: { children: React.ReactNode }) {
  return (
    <>
      <div className="flex-1">{children}</div>

      <div className="w-[1.8rem] h-[1.8rem] rounded-full border-0 bg-background-3 flex items-center justify-center shrink-0">
        <img src={shevronDown} alt="" />
      </div>
    </>
  );
}

export function ProtocolDropdown({ className }) {
  return (
    <div className={cx("tailwind relative", className)}>
      <Menu>
        <Menu.Button className="inline-flex rounded-sm items-center px-4 gap-4 hover:bg-background-3 cursor-pointer h-[3.6rem] border w-[12.8rem] transition">
          <MenuToggle>Synthetic</MenuToggle>
        </Menu.Button>

        <Menu.Items as="div" className="menu-items w-[20rem] !left-0">
          <div className="dropdown-label">
            <Trans>Select Protocol</Trans>
          </div>
          <Menu.Item>
            <div className="flex items-center justify-between p-[0.8rem] menu-item">
              <span className="ml-[0.8rem]">
                <Trans>Synthetic</Trans>
              </span>
            </div>
          </Menu.Item>

          <Menu.Item>
            <ExternalLink
              href="https://app.palmswap.org"
              className="flex items-center justify-between p-[0.8rem] menu-item"
              target="_self"
            >
              <span className="ml-[0.8rem]">
                <Trans>dvAMM</Trans>
              </span>
            </ExternalLink>
          </Menu.Item>

          <Menu.Item>
            <ExternalLink
              href="https://perp.palmswap.org"
              className="flex items-center justify-between p-[0.8rem] menu-item"
              target="_self"
            >
              <span className="ml-[0.8rem]">
                <Trans>Hybrid</Trans>
              </span>
            </ExternalLink>
          </Menu.Item>
        </Menu.Items>
      </Menu>
    </div>
  );
}
